import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: null,
    origem: null,
    settings: {},
    conversaToken: null,
    fluxoToken: null,
    proximoFluxoInteracaoToken: null,
    editarFluxoInteracaoToken: null,
    activeUserInteraction: false,
    activeUserInteractionInputType: null,
    respostaPlaceholder: null,
    respostaMask: null,
    respostaRegex: null,
    respostaName: null,
    respostaPadrao: null,
    respostaAutomatica: false,
    fullScreen: false
  },
  mutations: {
    updateToken (state, token) {
      state.token = token
    },
    updateOrigem (state, origem) {
      state.origem = origem
    },
    updateSettings (state, settings) {
      state.settings = settings
    },
    updateConversaToken (state, token) {
      state.conversaToken = token
    },
    updateFluxoToken (state, token) {
      state.fluxoToken = token
    },
    updateProximoFluxoInteracaoToken (state, token) {
      state.proximoFluxoInteracaoToken = token
    },
    updateEditarFluxoInteracaoToken (state, token) {
      state.editarFluxoInteracaoToken = token
    },
    updateActiveUserInteraction (state, active) {
      state.activeUserInteraction = active
    },
    updateActiveUserInteractionInputType (state, type) {
      state.activeUserInteractionInputType = type
    },
    updateRespostaPlaceholder (state, placeholder) {
      state.respostaPlaceholder = placeholder
    },
    updateRespostaMask (state, mask) {
      state.respostaMask = mask
    },
    updateRespostaRegex (state, regex) {
      state.respostaRegex = regex
    },
    updateRespostaName (state, name) {
      state.respostaName = name
    },
    updateRespostaPadrao (state, padrao) {
      state.respostaPadrao = padrao
    },
    updateRespostaAutomatica (state, automatica) {
      state.respostaAutomatica = automatica
    },
    updateFullScreen (state, value) {
      state.fullScreen = value
    }
  },
  getters: {
    chatbotName: state => {
      return state.settings.chatbotName || null;
    },
    chatbotImage: state => {
      return state.settings.chatbotImage || null;
    },
    chatbotImageLauncher: state => {
      return state.settings.chatbotImageLauncher || null;
    },
    chatbotImageFooter: state => {
      return state.settings.chatbotImageFooter || null;
    },
    chatbotColors: state => {
      return state.settings.chatbotColors || null;
    },
    chatbotChamada: state => {
      return state.settings.chatbotChamada || null;
    },
    customerActive: state => {
      return state.settings.customerActive || false;
    },
    isFullScreen: state => {
      return state.fullScreen;
    }
  }
})
